import {
    NOTE_GET_MULTIPLE,
    NOTE_GET_ONE,
    NOTE_REGISTER_SUCCESS,
    NOTE_REGISTER_FAIL,
    NOTE_LOADING,
    NOTE_LOADING_ERROR,
    NOTE_ACTIVATE_FAIL,
    NOTE_ACTIVATE_SUCCESS,
    NOTE_UPDATE_SUCCESS,
    NOTE_UPDATE_FAIL,
    NOTE_DELETE_SUCCESS,
    NOTE_DELETE_FAIL,
    NOTE_EDIT
} from "./../types/note";

let noteStore = JSON.parse(localStorage.getItem('note'))

const initialState = {
    isLoading: false,
    notes: noteStore ? noteStore : [],
    note:{},
    msg: null,
    isEdit:-1,
    ref:null,
}

const changeState = (aluu, actid) =>
{
    let newNote = [...aluu];
    newNote.forEach(alu => {
        if(alu.id == actid.id){
            alu.is_active = actid.is_active
        }
    });
    return newNote;
}
const func =  function(state = initialState, action){
    switch (action.type) {
        case NOTE_EDIT:
            return {
                ...state,
                isEdit : action.payload
        };
        case NOTE_LOADING:
            return {
                ...state,
                isLoading : true
            };
        case NOTE_GET_MULTIPLE:
            localStorage.setItem('note', JSON.stringify(action.payload));
            return {
                ...state,
                notes : action.payload,
                note : action.payload,
                isLoading : false,
                msg:'DONE!!!'
            };
        case NOTE_GET_ONE:
            let all = [...state.notes];
            let ses = all.filter(row=>row.id == action.payload)[0];
            return {
                ...state,
                note : ses,
                MSG:"DONE!!!"
            };
        case NOTE_REGISTER_SUCCESS:
            localStorage.setItem('note', JSON.stringify([...state.notes, action.payload]));
            return {
                ...state,
                notes: [...state.notes, action.payload],
                msg:action.msg
            }; 
        case NOTE_ACTIVATE_SUCCESS:
            let ac = changeState(state.notes, action.payload);
            localStorage.setItem('note', JSON.stringify(ac));
            return{
                ...state,
                msg:'DONE!!!',
                notes: ac
            }
        case NOTE_DELETE_SUCCESS:
            let rem = state.notes.filter(cat => cat.id != action.payload);
            localStorage.setItem('note', JSON.stringify(rem));
            return{
                ...state,
                msg:'DONE!!!',
                notes: rem
            }
        case NOTE_UPDATE_SUCCESS:
            const findInd = state.notes.findIndex(cat => cat.id == action.payload.id);
            let newState = [...state.notes];
            newState[findInd] = action.payload;
            localStorage.setItem('note', JSON.stringify(newState));
            return {
                ...state,
                ...action.payload,
                notes : newState,
                note:action.payload
            }; 
        case NOTE_LOADING_ERROR:
        case NOTE_ACTIVATE_FAIL:
        case NOTE_REGISTER_FAIL:
        case NOTE_DELETE_FAIL:
        case NOTE_UPDATE_FAIL:

            return {
                ...state,
                isLoading: false,
                msg: action.msg
            };
        default:
            return state;
    }

}
export default func